var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg navbar-dark kanban-navbar" },
    [
      _c("a", { staticClass: "navbar-brand", attrs: { href: _vm.baseurl } }, [
        _c("i", {
          staticClass: "fas fa-arrow-circle-left",
          attrs: { title: _vm.$t("kanbanBackToMenu").toString() }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "navbarSupportedContent" }
        },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _c("li", { staticClass: "nav-item mx-1 active" }, [
              _c("img", {
                attrs: {
                  width: "40px",
                  src: _vm.baseurl + "dist/img/revocheck-button-48px.png"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "nav-item mx-1" },
              [
                _c("OrganigramModal", {
                  ref: "organigramModal",
                  attrs: { modalId: "organigramModal1" },
                  on: { "account-selected": _vm.onAccountSelected }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#organigramModal1"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("txtAccount")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.state.settings
              ? _c("li", { staticClass: "nav-item mx-1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.alwaysShowMyBoards,
                        expression: "alwaysShowMyBoards"
                      }
                    ],
                    staticStyle: { height: "100%", "vertical-align": "middle" },
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.alwaysShowMyBoards)
                        ? _vm._i(_vm.alwaysShowMyBoards, null) > -1
                        : _vm.alwaysShowMyBoards
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.alwaysShowMyBoards,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.alwaysShowMyBoards = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.alwaysShowMyBoards = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.alwaysShowMyBoards = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("kanbanAlwaysShowMyBoards")) +
                        "\n        "
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav ml-auto align-items-center" }, [
            _vm.isFireProtection
              ? _c("li", { staticClass: "nav-item mx-1" }, [
                  _c("span", { staticClass: "badge badge-danger" }, [
                    _vm._v(_vm._s(_vm.$t("fireProtectionBadge")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item mx-1" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: _vm.baseurl + "manager/user/" + _vm.userid }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("kanbanHello") + " " + _vm.username + "!")
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item mx-1" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: _vm.baseurl + "manager/logout" }
                },
                [_vm._v(_vm._s(_vm.$t("kanbanLogout")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }